export function initBannerWithFilter() {
    document.querySelectorAll('.js-bannerWithFilter').forEach(el => {
        const tabs = Array.from(el.querySelectorAll('.js-bannerWithFilterTab'));
        const panels = Array.from(el.querySelectorAll('.js-bannerWithFilterPanel'));
        const bgs = Array.from(el.querySelectorAll('.bannerWithFilter__bg'));
        const indicator = el.querySelector('.bannerWithFilter__indicator');

        if (!tabs.length || !panels.length || !indicator) return;

        function activate(index) {
            tabs.forEach((tab, i) => {
                tab.classList.toggle('is-active', i === index);
                tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
            });

            panels.forEach((panel, i) => {
                panel.classList.toggle('is-active', i === index);
                panel.setAttribute('aria-hidden', i === index ? 'false' : 'true');
            });

            bgs.forEach((bg, i) => {
                bg.classList.toggle('is-active', i === index);
            });

            const activeTab = tabs[index];
            indicator.style.left = activeTab.offsetLeft + 'px';
            indicator.style.width = activeTab.offsetWidth + 'px';
        }

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => activate(i));
        });

        // Ersten Tab initial ohne Transition setzen (kein "Einflug"-Effekt)
        indicator.style.transition = 'none';
        activate(0);
        requestAnimationFrame(() => {
            indicator.style.transition = '';
        });

        function recalculate() {
            const current = tabs.findIndex(t => t.classList.contains('is-active'));
            if (current >= 0) {
                indicator.style.transition = 'none';
                activate(current);
                requestAnimationFrame(() => {
                    indicator.style.transition = '';
                });
            }
        }

        // Nach Font-Load neu berechnen (Barlow lädt ggf. asynchron)
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(recalculate);
        }

        // Bei Viewport-Resize neu berechnen (Orientation-Change, Breakpoint-Wechsel)
        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(recalculate).observe(el.querySelector('.bannerWithFilter__nav'));
        }
    });
}
